module.exports = __webpack_public_path__ + "static/scanner-f15de5816a475b1e75f1942932f6ab39.png";